import React from "react";
import { COMMISSION_QUEUE_VIEWS } from "./commissionsConstants";

const TONE = {
  active: {
    on: "border-emerald-500 bg-emerald-600 text-white",
    off: "border-gray-200 bg-white text-gray-600 hover:border-emerald-200 hover:text-emerald-700",
    badgeOn: "bg-white/20 text-white",
    badgeOff: "bg-gray-100 text-gray-600",
  },
  exceptions_reconciliation: {
    on: "border-orange-500 bg-orange-500 text-white",
    off: "border-gray-200 bg-white text-gray-600 hover:border-orange-200 hover:text-orange-700",
    badgeOn: "bg-white/20 text-white",
    badgeOff: "bg-orange-50 text-orange-700",
  },
  completed: {
    on: "border-sky-500 bg-sky-600 text-white",
    off: "border-gray-200 bg-white text-gray-600 hover:border-sky-200 hover:text-sky-700",
    badgeOn: "bg-white/20 text-white",
    badgeOff: "bg-gray-100 text-gray-600",
  },
  final_review: {
    on: "border-violet-500 bg-violet-600 text-white",
    off: "border-gray-200 bg-white text-gray-600 hover:border-violet-200 hover:text-violet-700",
    badgeOn: "bg-white/20 text-white",
    badgeOff: "bg-violet-50 text-violet-700",
  },
  all: {
    on: "border-gray-700 bg-gray-800 text-white",
    off: "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:text-gray-900",
    badgeOn: "bg-white/20 text-white",
    badgeOff: "bg-gray-100 text-gray-600",
  },
};

function CommissionsQueueTabs({ value = "active", counts = null, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {COMMISSION_QUEUE_VIEWS.map((view) => {
        const tone = TONE[view.id] || TONE.all;
        const active = value === view.id;
        const count =
          counts?.[view.id] ??
          (view.id === "exceptions_reconciliation"
            ? counts?.exceptions ?? counts?.reconciliation
            : undefined);
        const hasCount = Number.isFinite(Number(count));

        return (
          <button
            key={view.id}
            type="button"
            title={view.hint}
            onClick={() => onChange?.(view.id)}
            className={`inline-flex h-9 items-center gap-2 rounded-full border px-3.5 text-[13px] font-semibold transition-colors ${
              active ? tone.on : tone.off
            }`}
            style={{ boxShadow: "none", outline: "none" }}
          >
            {view.label}
            {hasCount ? (
              <span
                className={`inline-flex min-w-[20px] justify-center rounded-full px-1.5 py-0.5 text-[11px] font-bold tabular-nums ${
                  active ? tone.badgeOn : tone.badgeOff
                }`}
              >
                {count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

export default CommissionsQueueTabs;
